export const MAX_FILE_SIZE = 5242880 * 2; // 5MB
export const MAX_LENGTH_STORY_TEXT = 200;
export const ONE_HOUR = 3600000;
export const MAX_LENGTH_TWEET_META_HEADING = 50;
export const FIVE_MINUTES = 1000 * 60 * 5;

export const EMOJI_ICON = [
  "&#128512",
  "&#128513",
  "&#128514",
  "&#128515",
  "&#128516",
  "&#128517",
  "&#128518",
  "&#128519",
  "&#128520",
  "&#128521",
  "&#128522",
  "&#128523",
  "&#128524",
  "&#128525",
  "&#128526",
  "&#128527",
  "&#128528",
  "&#128529",
  "&#128530",
  "&#128531",
  "&#128532",
  "&#128533",
  "&#128534",
  "&#128535",
  "&#128536",
  "&#128537",
  "&#128538",
  "&#128539",
  "&#128540",
  "&#128541",
  "&#128542",
  "&#128543",
  "&#128544",
  "&#128545",
  "&#128546",
  "&#128547",
  "&#128548",
  "&#128549",
  "&#128550",
  "&#128551",
  "&#128552",
  "&#128553",
  "&#128554",
  "&#128555",
  "&#128556",
  "&#128557",
  "&#128558",
  "&#128559",
  "&#128560",
  "&#128561",
  "&#128562",
  "&#128563",
  "&#128564",
  "&#128565",
  "&#128566",
  "&#128567",
  "&#128577",
  "&#128578",
  "&#128579",
  "&#128580",
  "&#128512",
  "&#128513",
  "&#128514",
  "&#128515",
  "&#128516",
  "&#128517",
  "&#128518",
  "&#128519",
  "&#128520",
  "&#128521",
  "&#128522",
  "&#128523",
  "&#128524",
  "&#128525",
  "&#128526",
  "&#128527",
  "&#128528",
  "&#128529",
  "&#128530",
  "&#128531",
  "&#128532",
  "&#128533",
  "&#128534",
  "&#128535",
  "&#128536",
  "&#128537",
  "&#128538",
  "&#128539",
  "&#128540",
  "&#128541",
  "&#128542",
  "&#128543",
  "&#128544",
  "&#128545",
  "&#128546",
  "&#128547",
  "&#128548",
  "&#128549",
  "&#128550",
  "&#128551",
  "&#128552",
  "&#128553",
  "&#128554",
  "&#128555",
  "&#128556",
  "&#128557",
  "&#128558",
  "&#128559",
  "&#128560",
  "&#128561",
  "&#128562",
  "&#128563",
  "&#128564",
  "&#128565",
  "&#128566",
  "&#128567",
  "&#128577",
  "&#128578",
  "&#128579",
  "&#128580",
];
